var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9098 11.2155L28 8L25.2396 19.2122L21.7961 15.9064L16.2414 21.6925C16.0528 21.889 15.7923 22 15.52 22C15.2477 22 14.9872 21.889 14.7986 21.6925L10.72 17.444L4.72139 23.6925C4.33891 24.0909 3.70588 24.1039 3.30747 23.7214C2.90906 23.3389 2.89614 22.7059 3.27861 22.3075L9.99861 15.3075C10.1872 15.111 10.4477 15 10.72 15C10.9923 15 11.2528 15.111 11.4414 15.3075L15.52 19.556L20.3533 14.5213L16.9098 11.2155Z",
    fill: "#188A42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.91bb92a54175bad02ffe36a3e659e4d4.svg";
export { ForwardRef as ReactComponent };